import { Drawer, List } from '@mui/material';
import '../styleDrawer.css';
import HighwayContainerViewing from './ContainerViewing/HighwayContainerViewing'
import CantonContainerViewing from './ContainerViewing/CantonContainerViewing'
import OpticFilterContainerViewing from './ContainerViewing/OpticFilterContainerViewing'
import EquipmentFilterContainerViewing from './ContainerViewing/EquipmentFilterContainerViewing'
import CommunicationsFilterContainerViewing from './ContainerViewing/CommunicationsFilterContainerViewing'
import PoligonsFilterContainerViewing from './ContainerViewing/PoligonsFilterContainerViewing';
import FeatureFilterContainerViewing from './ContainerViewing/FeatureFilterContainerViewing';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER } from '../../Constants/ConstantsOptics';

//#region STYLE
  const customStyles = {
    control: base => ({
      ...base,
      background: '#4b4b4b',
      borderRadius: '5px',
      fontSize: '16px',
      border: '1px solid #ffffff',
      marginBottom: '5px',
    }),
    singleValue: base => ({
      ...base,
      color: '#ffffff', 
    }),
    input: base => ({
      ...base,
      color: '#ffffff', 
    }),
    menu: base => ({
      ...base,
      background: '#4b4b4b',
      color: '#ececec', 
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
      color: isFocused ? '#000000' : '#ececec', 
    }),
  };
//#endregion 

const DrawerMenuViewing = ({ openViewingDrawer, toggleViewingDrawer, loadingSummit,loadingCunton,
         toggleLayerVisibility,layersVisibility,
         canton, handleCantonChange,handleRegionChange,selectedRegionRef,regions,
          selectedAreaRef,area,handleClickCanton,layersVisibilityCommunications,
         toggleLayerVisibilityCommunications, handleLineCheckboxChange, showLines,
         city, handleCityChange, handleClickSummit, handleAreaChange,
         handleLine48CheckboxChange, showLines48,handleLine24CheckboxChange,showLines24,
         handleLine12CheckboxChange,showLines12,handleLine8CheckboxChange,showLines8,
         handleLine4CheckboxChange,showLines4,handleLine2CheckboxChange,showLines2,
         handleLine1CheckboxChange,showLines1, handleLine16CheckboxChange, showLines16, handleLine32CheckboxChange, showLines32,
         handleLine36CheckboxChange, showLines36,  handleLine64CheckboxChange, showLines64,
         handleLine72CheckboxChange, showLines72, handleLine96CheckboxChange, showLines96,handleLine144CheckboxChange, showLines144, handlePonLayerCheckboxChange,
         showPonLayer, handleLinesDenominationCheckboxChange,
         showLineDenomination, selectCityIsСhange,selectCantonIsСhange,
         selectedRegoin,selectedArea,showLinesTypeSolid, showLinesTypeDashed,
         handleLineTypeSolidCheckboxChange, handleLineTypeDashedCheckboxChange, handlePoligonCantonChange,
         showPolygonsCanton,handlePoligonAreaChange, showPolygonsArea,handleKtvLayerCheckboxChange, showKtvLayer,
         handleEtherLayerCheckboxChange,  showEtherLayer, handleLineTypeBasementCheckboxChange, showLinesTypeBasement,
         handleLineTypeFacadeCheckboxChange, showLinesTypeFacade, handleLineTypeLoftCheckboxChange, showLinesTypeLoft,
         handleLineTypeRoofCheckboxChange, showLinesTypeRoof, handleHousesChange, showHouses, handleNumberPonBoxCheckboxChange,
         visibleNumberPonBox, handleLineRankSummitToCantonCheckboxChange,
         showLinesRankSummitToCanton, highwayTerritory, handleLineAirBetweenHousesCheckboxChange, showAirBetweenHouses,
         handleLineAirPillarsCheckboxChange, showAirPillars, handleHousesActivatedPassiveChange, showHousesActivatedPassive,
         handleLine6CheckboxChange,showLines6}) => {
          
          

          const roleId = localStorage.getItem('roleId');
          const territory = localStorage.getItem('territory');

          const allowedRoles = [ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER];
          const showHighwayContainer = allowedRoles.includes(roleId);

          const cantonToUse = getFilteredCanton(territory, canton, roleId);

          function getFilteredCanton(territoryRaw, canton, roleId) {
            const userTerritory = (territoryRaw || '').trim();

            if (roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER) {
              return canton; // полный доступ
            }

            if (userTerritory.toLowerCase() === 'full') {
              return canton;
            }

            if (!userTerritory) {
              return []; // ничего не передаём
            }

            // работает по мастерам только один округ показывает 
            // const normalizedCanton = canton.map(c => c.trim());
            // return normalizedCanton.includes(userTerritory) ? [userTerritory] : [];

             // работает по мастерам все их округа показывает 
            const normalizedCanton = canton.map(c => c.trim());

              const userTerritories = userTerritory
                  .split(',')
                  .map(t => t.trim());

              return normalizedCanton.filter(c =>
                  userTerritories.includes(c)
              );
          }

        // function getFilteredCanton(territoryRaw, canton) {
        //   const userTerritory = (territoryRaw || '').trim();
        
        //   if (userTerritory.toLowerCase() === 'full') {
        //     return canton;
        //   }
        
        //   if (!userTerritory) {
        //     return []; // ничего не передаём
        //   }
        
        //   const normalizedCanton = canton.map(c => c.trim());
        //   return normalizedCanton.includes(userTerritory) ? [userTerritory] : [];
        // }
      
  return (
    <Drawer
      open={openViewingDrawer}
      onClose={toggleViewingDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar', style: { width: "260px" } }}
     
    >
      <div className="divTitleDrawer">
        <p className='textTitleDrawer'>Просмотр</p>
      </div>

      <List>
        <div className='divBodyDrawer'> 
           <div>
              <label className='textTitleDrawer' style={{fontSize: "16px",textShadow: '2px 2px 4px #242424'}}>Отобразить территорию</label>
              <hr className="horizontalLineDrawer" style={{marginTop: "5px"}}/>  

              {/* Просмотр территории годод/страна */}
            {showHighwayContainer && (
              <HighwayContainerViewing
                handleCityChange={handleCityChange}
                city={city}
                customStyles={customStyles}
                handleClickSummit={handleClickSummit}
                loadingSummit={loadingSummit}
                selectCityIsСhange={selectCityIsСhange}
              />
            )}
              
              {/* Просмотр территории округ / регион / ветка */}
              <CantonContainerViewing
                handleCantonChange={handleCantonChange}
                canton={cantonToUse}
                customStyles={customStyles}
                handleRegionChange={handleRegionChange}
                regions={regions}
                area={area}
                handleClickCanton={handleClickCanton}
                loadingCunton={loadingCunton}
                selectedRegionRef={selectedRegionRef}
                selectedAreaRef={selectedAreaRef}
                handleAreaChange={handleAreaChange}
                selectCantonIsСhange={selectCantonIsСhange}
                selectedRegoin={selectedRegoin}
                selectedArea={selectedArea}
              />
            </div> 
        </div>

        <div className='divBodyDrawer'>
          <label className='textTitleDrawer' style={{fontSize: "16px", marginBottom: "5px",textShadow: '2px 2px 4px #242424'}}>Фильтр</label>
          <hr className="horizontalLineDrawer" style={{marginBottom: "10px"}}/>  

            {/* фильтр полигонов */}
            <PoligonsFilterContainerViewing
              handlePoligonCantonChange={handlePoligonCantonChange}
              showPolygonsCanton={showPolygonsCanton}
              handlePoligonAreaChange={handlePoligonAreaChange}
              showPolygonsArea={showPolygonsArea}
              handleHousesChange={handleHousesChange}
              showHouses={showHouses}
              handleLineRankSummitToCantonCheckboxChange={handleLineRankSummitToCantonCheckboxChange}
              showLinesRankSummitToCanton={showLinesRankSummitToCanton}
              highwayTerritory={highwayTerritory}
              roleId={roleId}
              allowedRoles={allowedRoles}
              handleHousesActivatedPassiveChange={handleHousesActivatedPassiveChange}
              showHousesActivatedPassive={showHousesActivatedPassive}
            />
            <br/>
            {/* фильтр оптика */}
            <OpticFilterContainerViewing
              showLines={showLines}
              handleLineCheckboxChange={handleLineCheckboxChange}
              handleLine48CheckboxChange={handleLine48CheckboxChange}
              showLines48={showLines48}
              handleLine24CheckboxChange={handleLine24CheckboxChange}
              showLines24={showLines24}
              handleLine12CheckboxChange={handleLine12CheckboxChange}
              showLines12={showLines12}
              handleLine8CheckboxChange={handleLine8CheckboxChange}
              showLines8={showLines8}
              handleLine4CheckboxChange={handleLine4CheckboxChange}
              showLines4={showLines4}
              handleLine2CheckboxChange={handleLine2CheckboxChange}
              showLines2={showLines2}
              handleLine1CheckboxChange={handleLine1CheckboxChange}
              showLines1={showLines1}
              handleLine16CheckboxChange={handleLine16CheckboxChange}
              showLines16={showLines16}
              handleLine32CheckboxChange={handleLine32CheckboxChange}
              showLines32={showLines32}
              handleLine36CheckboxChange={handleLine36CheckboxChange}
              showLines36={showLines36}
              handleLine64CheckboxChange={handleLine64CheckboxChange}
              showLines64={showLines64}
              handleLine72CheckboxChange={handleLine72CheckboxChange}
              showLines72={showLines72}
              handleLine96CheckboxChange={handleLine96CheckboxChange}
              showLines96={showLines96}
              handleLine144CheckboxChange={handleLine144CheckboxChange}
              showLines144={showLines144}
              showLinesTypeSolid={showLinesTypeSolid}
              showLinesTypeDashed={showLinesTypeDashed}
              handleLineTypeSolidCheckboxChange={handleLineTypeSolidCheckboxChange}
              handleLineTypeDashedCheckboxChange={handleLineTypeDashedCheckboxChange}
              handleLinesDenominationCheckboxChange={handleLinesDenominationCheckboxChange}
              showLineDenomination={showLineDenomination}
              handleLineTypeBasementCheckboxChange={handleLineTypeBasementCheckboxChange}
              showLinesTypeBasement={showLinesTypeBasement}
              handleLineTypeFacadeCheckboxChange={handleLineTypeFacadeCheckboxChange}
              showLinesTypeFacade={showLinesTypeFacade}           
              handleLineTypeLoftCheckboxChange={handleLineTypeLoftCheckboxChange}
              showLinesTypeLoft={showLinesTypeLoft}
              handleLineTypeRoofCheckboxChange={handleLineTypeRoofCheckboxChange}
              showLinesTypeRoof={showLinesTypeRoof}
              handleLineAirBetweenHousesCheckboxChange={handleLineAirBetweenHousesCheckboxChange}
              showAirBetweenHouses={showAirBetweenHouses}
              handleLineAirPillarsCheckboxChange={handleLineAirPillarsCheckboxChange}
              showAirPillars={showAirPillars}
              handleLine6CheckboxChange={handleLine6CheckboxChange}
              showLines6={showLines6}
            />

            
            <br/>
            {/* фильтр оборудование */}
            <EquipmentFilterContainerViewing
              layersVisibility={layersVisibility}
              toggleLayerVisibility={toggleLayerVisibility}
            />
            <br/>
            {/* фильтр коммуникации */}
            <CommunicationsFilterContainerViewing
              layersVisibilityCommunications={layersVisibilityCommunications}
              toggleLayerVisibilityCommunications={toggleLayerVisibilityCommunications}
              handleNumberPonBoxCheckboxChange={handleNumberPonBoxCheckboxChange}
              visibleNumberPonBox={visibleNumberPonBox}
            />

            {/* фильтр признаков */}
            <FeatureFilterContainerViewing
               showPonLayer={showPonLayer}
               handlePonLayerCheckboxChange={handlePonLayerCheckboxChange}
               showKtvLayer={showKtvLayer}
               handleKtvLayerCheckboxChange={handleKtvLayerCheckboxChange}
               showEtherLayer={showEtherLayer}
               handleEtherLayerCheckboxChange={handleEtherLayerCheckboxChange}               
            />
              
            
         </div>
      </List>
    </Drawer>    
  );
};

export default DrawerMenuViewing;